import React, { useState, useEffect } from 'react';
import {
  getChannelById,
  getCostCenterById,
  getCostCenters,
  getRegionById,
  getRegions,
  isChanelSameBusinessArea,
  mapChanneldata,
  mapCostCenterData,
  mapRegionData,
} from './Functions';
import { useGlobalContext } from '../../../../../../context/GlobalContext';
import { ServiceClient } from '../../../../../../Services/ServiceClient';
import SearchableDropdownInput from '../../../../../../Elements/SearchableDropdownInput';
import { formatMessage } from '../../../../../../Localization/formatMessage';
import Messages from '../../../../../../Localization/Messages';
import { mapLegalUnitCodeToName } from '../../../../../../Helpers/AgentHelper';

const ChannelDataHandler = ({ editedAgent, setEditedAgent }) => {
  const [selectedChannelId, setSelectedChannelId] = useState(editedAgent.channel?.id);
  const [selectedRegionId, setSelectedRegionId] = useState(editedAgent.region?.id);
  const [selectedCostCenterId, setSelectedCostCenterId] = useState(editedAgent.costCenterId);
  const [costCenterList, setCostCenterList] = useState([]);
  const [regionList, setRegionList] = useState([]);
  const [channelList, setChannelList] = useState([]);

  const { legalUnit, businessArea } = useGlobalContext();

  useEffect(() => {
    ServiceClient.getChannels(data => {
      const tempChannels = [];
      const tempCostCenters = [];
      const tempRegions = [];

      data
        .filter(channel => isChanelSameBusinessArea(channel, businessArea))
        .forEach(channel =>
          channel.regions.forEach(region => {
            if (region.legalUnitName === mapLegalUnitCodeToName(legalUnit) && region.costCenters.length > 0) {
              if (!tempChannels.some(x => x.id === channel.id)) {
                tempChannels.push(mapChanneldata(channel));
              }

              tempRegions.push(mapRegionData(region, channel));

              region.costCenters.forEach(costCenter => {
                tempCostCenters.push(mapCostCenterData(costCenter, region, channel));
              });
            }
          })
        );

      setCostCenterList(tempCostCenters);
      setRegionList(tempRegions);
      setChannelList(tempChannels);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onChannelChange = id => {
    const result = channelList.find(channel => channel.id === id);
    setSelectedChannelId(result.id);
    setSelectedRegionId(null);
    setSelectedCostCenterId(null);
    setEditedAgent({ ...editedAgent, costCenterId: null });
  };

  const onRegionChange = id => {
    const result = regionList.find(region => region.id === id);
    setSelectedChannelId(result.channelId);
    setSelectedRegionId(result.id);
    setSelectedCostCenterId(null);
    setEditedAgent({ ...editedAgent, costCenterId: null });
  };

  const onCostCenterChange = id => {
    const result = costCenterList.find(costCenter => costCenter.id === id);
    setSelectedChannelId(result.channelId);
    setSelectedRegionId(result.regionId);
    setSelectedCostCenterId(result.id);
    setEditedAgent({ ...editedAgent, costCenterId: result.id });
  };

  return (
    <>
      <SearchableDropdownInput
        items={channelList}
        onChange={onChannelChange}
        selectedItem={getChannelById(selectedChannelId, channelList)}
        label={formatMessage(Messages.agentInfo_channel)}
      />
      <SearchableDropdownInput
        items={getRegions(regionList, selectedChannelId)}
        onChange={onRegionChange}
        selectedItem={getRegionById(selectedRegionId, regionList)}
        label={formatMessage(Messages.agentInfo_region)}
      />
      <SearchableDropdownInput
        items={getCostCenters(costCenterList, selectedRegionId, selectedChannelId)}
        onChange={onCostCenterChange}
        selectedItem={getCostCenterById(selectedCostCenterId, costCenterList)}
        isMandatory={true}
        label={formatMessage(Messages.agentInfo_costCenter)}
      />
    </>
  );
};

export default ChannelDataHandler;
